// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1alsZ","toggle":"styles_toggle__2ujpV","preview":"styles_preview__1imzn"};